export default __webpack_public_path__ + "static/3-06ff3fd7abaeba521e0951eda6b0a938.png";